import React, { useState } from 'react';
import { PropTypes } from 'prop-types';
// styles
import styled, { css } from 'styled-components';
import { ChevronBottomIcon } from 'refactored/ui/icons';
import { useSoFormStepsApi } from 'refactored/features/soForm/SoForm.context';
import { useClickOutside } from 'refactored/ui/utils';
//
import { useTranslation } from 'react-i18next';

const InputFrame = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  padding: 0px;
  height: 40px;
  flex: none;
  order: 0;
  flex-grow: 1;
  cursor: pointer;
`;

const SoFormLoadSizeInputLabel = styled.div`
  height: 16px;
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  line-height: 16px;
  display: flex;
  align-items: center;
  color: var(--grey500);
  flex: none;
  order: 0;
  flex-grow: 0;
`;

const SoFormLoadSizeInputSubFrame = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: start;
  align-items: center;
  padding: 0px;
  gap: 8px;
  height: 24px;
  flex: none;
  order: 1;
  align-self: stretch;
  flex-grow: 0;
`;

const SoFormLoadSizeInputContent = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 0px;
  gap: 8px;

  height: 24px;
  /* border: 1px solid red; */
`;

const SoFormLoadSizeInputSubfixFrame = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  padding: 0px;
  gap: 10px;
  width: 17px;
  height: 16px;
  flex: none;
  order: 1;
  flex-grow: 0;
  /* background: red; */
`;

const SoFormLoadSizeInputSubfix = styled.div`
  /* width: 17px; */
  /* height: 16px; */

  font-family: 'Roboto';
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  line-height: 16px;
  display: flex;
  align-items: center;
  color: var(--grey500);
  flex: none;
  order: 0;
  flex-grow: 0;
  font-size: 24px;
  position: absolute;
  top: 16px;
  right: 16px;
`;

const Dropdown = styled.div`
  position: absolute;
  left: 0;
  right: 0;
  top: 50px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 0px;

  /* grey / 100 */

  background: #f2f5f8;
  /* grey / 300 */

  border: 1px solid #ccd6e0;
  border-radius: 4px;
  z-index: 1;
`;

const DropdownOption = styled.div`
  box-sizing: border-box;

  /* Auto layout */

  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 8px 16px;
  gap: 10px;

  /* width: 424px; */
  height: 40px;

  /* primary / 100 */
  cursor: pointer;

  &:hover {
    /* grey / 200 */
    background: #e0eaff;
  }

  border-bottom: 1px solid #e2e8ee;
  width: 100%;
`;

const DropdownOptionContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 0px;
  gap: 8px;

  height: 24px;
`;

const DropdownOptionLabel = styled.div`
  height: 24px;

  /* 16px/regular

Shipper App Default
*/
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  /* identical to box height, or 150% */

  /* grey / 800 */

  color: #3b4f63;
`;

const DropdownOptionSublabel = styled.div`
  height: 16px;

  /* 14px/regular */

  font-family: 'Roboto';
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 16px;
  /* identical to box height, or 114% */

  /* grey / 700 */

  color: #54708c;
`;

const SoFormLoadSubtypeControl = styled(({ className, load }) => {
  const { t } = useTranslation('Catalog');

  const optionsPalletized = [
    {
      label: t('configuration.loads.types.EU_PALLET'),
      sublabel: '(120 x 80cm)',
      value: 'EU_PALLET',
    },
    {
      label: t('configuration.loads.types.US_PALLET'),
      sublabel: '(120 x 100cm)',
      value: 'US_PALLET',
    },
    {
      label: t('configuration.loads.types.CUSTOM_PALLET'),
      sublabel: t('configuration.loads.types.CUSTOM_PALLET_DEFAULT_SUBLABEL'),
      value: 'CUSTOM_PALLET',
    },
  ];
  const optionsNonpalletized = [
    {
      label: t('configuration.loads.types.BOX'),
      sublabel: '(60 x 40 x 40cm)',
      value: 'BOX',
    },
    {
      label: t('configuration.loads.types.CUSTOM_BOX'),
      sublabel: t('configuration.loads.types.CUSTOM_BOX_DEFAULT_SUBLABEL'),
      value: 'CUSTOM_BOX',
    },
    {
      label: t('configuration.loads.types.BULK'),
      sublabel: '',
      value: 'BULK',
    },
  ];
  // state
  const stepsApi = useSoFormStepsApi();

  const selectedLoadType = load.load_type;
  const selectedPalletType = load.pallet_type;
  const { item_length, item_width, item_height } = load;

  const isPalletized = selectedLoadType === 'PALLET';
  const isStandardBox =
    item_height === 40 && item_width === 40 && item_length === 60;

  const options = isPalletized ? optionsPalletized : optionsNonpalletized;

  let selectedOption = null;

  if (isPalletized) {
    selectedOption = options.find((o) => o.value === selectedPalletType);
  } else {
    if (selectedLoadType === 'BULK') selectedOption = options[2];
    else {
      selectedOption = isStandardBox ? options[0] : options[1];
    }
  }

  const placeholder = t('configuration.loads.type_placeholder');

  const customSublabel = isPalletized
    ? `(${item_length} x ${item_width} cm)`
    : `(${item_length} x ${item_width} x ${item_height} cm)`;

  const showCustomLabelForPalletized =
    selectedPalletType === 'CUSTOM_PALLET' &&
    item_length !== '' &&
    item_length !== 0 &&
    item_width !== '' &&
    item_width !== 0;

  const showCustomLabelForNonpalletized =
    selectedLoadType === 'PARCEL' &&
    !isStandardBox &&
    item_length !== '' &&
    item_length !== 0 &&
    item_width !== '' &&
    item_width !== 0 &&
    item_height !== '' &&
    item_height !== 0;

  const showCustomLabel = isPalletized
    ? showCustomLabelForPalletized
    : showCustomLabelForNonpalletized;

  const [isOpened, setIsOpened] = useState(false);
  const selectOption = (option) => {
    stepsApi.setPalletType({ load, value: option.value });
    setIsOpened(false);
  };

  const clickRef = React.useRef();
  useClickOutside(clickRef, () => {
    setIsOpened(false);
  });
  return (
    <div className={className}>
      <InputFrame
        ref={clickRef}
        onClick={() => {
          setIsOpened(!isOpened);
        }}
      >
        <SoFormLoadSizeInputLabel>{placeholder}</SoFormLoadSizeInputLabel>
        <SoFormLoadSizeInputSubFrame>
          <SoFormLoadSizeInputContent>
            <DropdownOptionLabel>{selectedOption.label}</DropdownOptionLabel>
            <DropdownOptionSublabel>
              {showCustomLabel ? customSublabel : selectedOption.sublabel}
            </DropdownOptionSublabel>
          </SoFormLoadSizeInputContent>
          <SoFormLoadSizeInputSubfixFrame>
            <SoFormLoadSizeInputSubfix>
              <ChevronBottomIcon />
            </SoFormLoadSizeInputSubfix>
          </SoFormLoadSizeInputSubfixFrame>
        </SoFormLoadSizeInputSubFrame>
      </InputFrame>
      {isOpened && (
        <Dropdown>
          {options.map((o) => (
            <DropdownOption onClick={() => selectOption(o)}>
              <DropdownOptionContainer>
                <DropdownOptionLabel>{o.label}</DropdownOptionLabel>
                <DropdownOptionSublabel>{o.sublabel}</DropdownOptionSublabel>
              </DropdownOptionContainer>
            </DropdownOption>
          ))}
        </Dropdown>
      )}
    </div>
  );
})``;

SoFormLoadSubtypeControl.propTypes = {
  className: PropTypes.string,
};

const regularCSS = css`
  box-sizing: border-box;
  flex: 1;

  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: flex-end;
  padding: 6px 12px 2px 16px;
  gap: 12px;

  height: 48px;

  border-width: 1px 1px 1px 4px;
  border-style: solid;
  border-color: var(--grey300);
  border-radius: 4px;

  flex: none;
  order: 0;
  flex-grow: 1;
  position: relative;
`;

export default styled(SoFormLoadSubtypeControl)`
  ${regularCSS}
`;
